import { Phone, MapPin, Mail, Clock } from "lucide-react";
import { useSite } from "@/context/SiteContext";
import { Seo } from "@/components/site/Seo";
import { PageHero } from "@/components/site/PublicLayout";
import { WhatsAppIcon } from "@/components/site/WhatsAppFab";
import { WEEKDAYS, waLink } from "@/lib/helpers";

export default function Contact() {
  const { site } = useSite();
  const mapQ = site?.maps_query || "";
  return (
    <>
      <Seo title="İletişim" description="Masal Sanat Akademi iletişim bilgileri, adres, çalışma saatleri ve harita." />
      <PageHero eyebrow="İletişim" title="Bize ulaşın" />
      <section className="mx-auto max-w-7xl px-4 sm:px-6 lg:px-8 py-14 grid lg:grid-cols-12 gap-8">
        <div className="lg:col-span-5 space-y-5">
          <div className="rounded-3xl border border-bej p-6 space-y-4" data-testid="contact-info">
            {site?.phone && <p className="flex gap-3 font-semibold text-navy"><Phone className="w-5 h-5" /><a href={`tel:${site.phone.replace(/\s/g, "")}`}>{site.phone}</a></p>}
            {site?.address && <p className="flex gap-3 text-slate-700"><MapPin className="w-5 h-5 text-navy shrink-0" />{site.address}</p>}
            {site?.public_email && <p className="flex gap-3 text-slate-700"><Mail className="w-5 h-5 text-navy" />{site.public_email}</p>}
            {site?.whatsapp_number && (
              <a href={waLink(site.whatsapp_number, "Merhaba, bilgi almak istiyorum.")} target="_blank" rel="noreferrer" data-testid="contact-whatsapp-btn"
                className="inline-flex items-center gap-2 rounded-full bg-[#25D366] px-6 py-3 font-heading font-bold text-white">
                <WhatsAppIcon className="w-5 h-5" /> WhatsApp'tan yaz
              </a>
            )}
          </div>
          <div className="rounded-3xl bg-bej-light p-6" data-testid="contact-hours">
            <h2 className="flex items-center gap-2 font-heading text-lg font-extrabold text-navy mb-3"><Clock className="w-5 h-5" /> Çalışma saatleri</h2>
            {!site?.working_hours ? <p className="text-sm text-slate-400">Yükleniyor…</p> : <ul className="space-y-1.5 text-sm">
              {WEEKDAYS.map((d, i) => {
                const wh = site?.working_hours?.[String(i)];
                return (
                  <li key={d} className="flex justify-between">
                    <span className="font-semibold text-navy">{d}</span>
                    <span className="text-slate-700">{wh?.open ? `${wh.start} – ${wh.end}` : "Kapalı"}</span>
                  </li>
                );
              })}
            </ul>}
          </div>
        </div>
        <div className="lg:col-span-7 rounded-3xl overflow-hidden border border-bej min-h-[360px] bg-bej-light" data-testid="contact-map">
          {mapQ ? (
            <iframe title="Google Haritalar" className="w-full h-full min-h-[420px]" loading="lazy" referrerPolicy="no-referrer-when-downgrade"
              src={`https://www.google.com/maps?q=${encodeURIComponent(mapQ)}&output=embed`} />
          ) : (
            <div className="h-full min-h-[360px] grid place-items-center p-8 text-center text-navy/70">
              Harita, Yönetim Paneli → Ayarlar bölümünden adres/harita bilgisi girildiğinde burada görünecek.
            </div>
          )}
        </div>
      </section>
    </>
  );
}
